var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":_vm.path_to_pokemon_with_id(_vm.poke_id)}},[_c('v-btn',{attrs:{"small":"","tile":""}},[_vm._v(_vm._s(_vm.nameString(_vm.poke_id))+_vm._s(_vm.alolaNameString()))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }